import { Component, OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { CaseService } from '@app/core/services/case.service';
import { CaseComponent } from '@app/modules/case/components/case-base/case.component';

@Component({
    templateUrl: './case-detailed-lawyer.component.html',
    styleUrls: ['./case-detailed-lawyer.component.scss']
})
export class CaseDetailedLawyerComponent extends CaseComponent
    implements OnInit {

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected caseService: CaseService) {
        super(componentServiceBundle, caseService);
        this._idPrefix = 'case_detailed_lawyer.';
    }

    public ngOnInit() {
        super.ngOnInit();
    }
}
